import { createEmptyWorld, worldSchema, type World } from '@ebu/world-schema';

/**
 * Starting points for a new project. "Lighthouse lantern room" matches the film and the Lab: a
 * table with a battery, a switch and a lamp that are not wired yet, plus a little decor.
 */
export type StarterId = 'empty' | 'lighthouse';
export const STARTERS: readonly StarterId[] = ['empty', 'lighthouse'];

/** Texts come from the UI language (i18n), never hard-coded. */
export function starterWorld(
  starter: StarterId,
  input: { id: string; title: string; now: Date; posterCaption: string },
): World {
  const world = createEmptyWorld(input);
  if (starter === 'empty') return world;
  return worldSchema.parse({
    ...world,
    objects: [
      {
        id: 'table-1',
        type: 'table',
        position: [0, 0, 0],
        rotationY: 0,
        scale: 1,
        props: { colour: 'natural' },
      },
      {
        id: 'battery-1',
        type: 'battery',
        position: [-0.5, 0.8, 0],
        rotationY: 0,
        scale: 1,
        props: {},
      },
      {
        id: 'switch-1',
        type: 'switch',
        position: [0, 0.8, 0.3],
        rotationY: 0,
        scale: 1,
        props: { closed: false },
      },
      { id: 'lamp-1', type: 'lamp', position: [0.5, 0.8, 0], rotationY: 0, scale: 1, props: {} },
      {
        id: 'window-1',
        type: 'window',
        position: [0, 1.5, -4.5],
        rotationY: 0,
        scale: 1,
        props: { colour: 'sky' },
      },
      {
        id: 'rug-1',
        type: 'rug',
        position: [0, 0, 1.5],
        rotationY: 0,
        scale: 1.5,
        props: { colour: 'berry' },
      },
      {
        id: 'plant-1',
        type: 'plant',
        position: [-3, 0, -3.5],
        rotationY: 0,
        scale: 1,
        props: { colour: 'leaf' },
      },
      {
        id: 'poster-1',
        type: 'poster',
        position: [3, 1.5, -4.5],
        rotationY: 0,
        scale: 1,
        props: { colour: 'sun', caption: input.posterCaption.slice(0, 40) },
      },
    ],
  });
}
